<template>
  <div class="form-group">
    <label class="label">{{ title }}</label>

    <div v-for="(item, index) in modelItems" :key="index + '.InputRow'" class="row form-group">
      <div class="col-12">
        <w-textarea
          :model="item.model"
          :disabled="checkAllProperty(item, 'disabled')"
          :placeholder="item.placeholder"
          :appendicon="item.appendicon"
          :prependicon="item.prependicon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';

// @vuese
// Textarea row component
// // @Group detailsComponents
export default {
  mixins: [componentMixin],
  props: {
    // Przekazuję obiekt z wartościami jak disbaled itp.
    allParametrs: { type: Object, required: false }
  },
  methods: {
    // @vuese
    // Zwraca podane property lub property `all`
    checkAllProperty(item, property) {
      return (this.allParametrs && this.allParametrs[property]) || item[property];
    }
  }
};
</script>
